import { render, staticRenderFns } from "./cotinine-cot-rapid-test_pc.vue?vue&type=template&id=598911b5&scoped=true&"
import script from "./cotinine-cot-rapid-test_pc.vue?vue&type=script&lang=js&"
export * from "./cotinine-cot-rapid-test_pc.vue?vue&type=script&lang=js&"
import style0 from "./cotinine-cot-rapid-test_pc.vue?vue&type=style&index=0&id=598911b5&scoped=true&lang=less&"
import style1 from "./cotinine-cot-rapid-test_pc.vue?vue&type=style&index=1&id=598911b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598911b5",
  null
  
)

export default component.exports